import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../lesson-02/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "3b58b6be-35ef-4885-9364-5503b18d99e4",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
];

export default lessonLinks;
